export function makeRequest(api, url, options) {
  return api(url, options)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error.response));
}
